"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forward = exports.back = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.locationChangeAction = exports.LOCATION_CHANGE = exports.CALL_HISTORY_METHOD = void 0;
exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var locationChangeAction = function (location, action) { return ({
    type: exports.LOCATION_CHANGE,
    payload: { location: location, action: action },
}); };
exports.locationChangeAction = locationChangeAction;
function updateLocation(method) {
    // @ts-ignore //support history 5.x back/forward
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ({
            type: exports.CALL_HISTORY_METHOD,
            payload: { method: method, args: args },
        });
    };
}
exports.push = updateLocation('push');
exports.replace = updateLocation('replace');
exports.go = updateLocation('go');
exports.goBack = updateLocation('goBack');
exports.goForward = updateLocation('goForward');
// @ts-ignore //support history 5.x back/forward
exports.back = updateLocation('back');
// @ts-ignore //support history 5.x back/forward
exports.forward = updateLocation('forward');
//# sourceMappingURL=actions.js.map